export default __webpack_public_path__ + "static/media/tick.ae1e29ef.svg";